import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation
} from '@angular/core';
import { CertificateComponent } from '../../sprinklers/certificate-sprinklers/certificate.component';

@Component({
  selector: 'authority-labs-certificate-fire-alarm-system',
  templateUrl: './certificate-fire-alarm-system.component.html',
  styleUrls: ['./certificate-fire-alarm-system.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificateFireAlarmSystemComponent extends CertificateComponent {}
